import { Dispatch, SetStateAction, useState } from "react";
import {
  Modal,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { FeatureType, SubGroup } from "../types/types";

interface AddFeatureProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  groupId: number;
  subGroups?: SubGroup[]; // pass subgroup list
}

const AddFeature: React.FC<AddFeatureProps> = ({
  open,
  setOpen,
  groupId,
  subGroups = [],
}) => {
  const [name, setName] = useState("");
  const [type, setType] = useState<FeatureType>("Any");

  const [assignTo, setAssignTo] = useState<"group" | "subgroup">("group");
  const [selectedSubGroup, setSelectedSubGroup] = useState<number | "">("");

  const handleSave = () => {
    const payload = {
      name,
      type,
      groupId,
      subGroupId: assignTo === "subgroup" ? selectedSubGroup : null,
    };

    console.log("Payload:", payload);
    setOpen(false);
  };

  return (
    <Modal className="modal rejectReason_modal" open={open}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Add Feature</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </button>
          </div>

          <div className="form">
            <div className="gap_p">
              {/* Feature Name */}
              <div className="control_group">
                <label>Feature Name</label>
                <TextField
                  fullWidth
                  hiddenLabel
                  placeholder="Enter Feature Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>

              {/* Assign To */}
              <div className="control_group">
                <label>Assign To</label>
                <RadioGroup
                  sx={{ mt: 1 }}
                  className="flex"
                  value={assignTo}
                  onChange={(e) =>
                    setAssignTo(e.target.value as "group" | "subgroup")
                  }
                >
                  <FormControlLabel
                    value="group"
                    control={<Radio />}
                    label="This Group"
                  />

                  <FormControlLabel
                    value="subgroup"
                    control={<Radio />}
                    label="Sub Group"
                  />
                </RadioGroup>
              </div>

              {/* Sub Group Dropdown */}
              {assignTo === "subgroup" && (
                <div className="control_group">
                  <label>Select Sub Group</label>
                  <Select
                    fullWidth
                    value={selectedSubGroup}
                    onChange={(e) =>
                      setSelectedSubGroup(e.target.value as number)
                    }
                    displayEmpty
                  >
                    <MenuItem value="">Select Sub Group</MenuItem>
                    {subGroups.map((sg) => (
                      <MenuItem key={sg.id} value={sg.id}>
                        {sg.name}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              )}
            </div>

            <div className="footer_btn_flex">
              <Button className="btn btn_primary" onClick={handleSave}>
                Save
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddFeature;